import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 啟用物料。
 * `POST /mtr/{id}/activate`；body `{ updatedAt }`（不送 id）。
 *
 * @param {string} id
 * @param {{ updatedAt?: string }} [payload]
 */
export async function activateMtr(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mtr/${id}/activate`,
    keysToSnake({ updatedAt: payload.updatedAt }),
  );
  return parseVer4DetailResponse(raw);
}
